<template>
  <div class="administrar-proyecto">
    <h3 class="mb-4">
      <font-awesome-icon icon="fas fa-folder" class="me-2" /> Administrar Proyecto
    </h3>

    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button class="nav-link active" id="nav-info-tab" data-bs-toggle="tab" data-bs-target="#nav-info" type="button"
          role="tab" aria-controls="nav-info" aria-selected="true">
          <font-awesome-icon icon="fas fa-info-circle" class="me-1" /> Información del Proyecto
        </button>
        <button class="nav-link" id="nav-cierre-tab" data-bs-toggle="tab" data-bs-target="#nav-cierre" type="button"
          role="tab" aria-controls="nav-cierre" aria-selected="false">
          <font-awesome-icon icon="fas fa-times-circle" class="me-1" /> Cerrar Proyecto
        </button>

      </div>
    </nav>

    <div class="tab-content mt-4" id="nav-tabContent">
      <!-- Información del Proyecto -->
      <div class="tab-pane fade show active" id="nav-info" role="tabpanel" aria-labelledby="nav-info-tab">
        <div class="proyecto-info shadow-sm p-3 rounded bg-light">
          <h4>Información del Proyecto</h4>
          <p><strong>Nombre:</strong> {{ proyecto.nombre }}</p>
          <p><strong>Descripción:</strong> {{ proyecto.descripcion }}</p>
          <p><strong>Fecha Inicio:</strong> {{ proyecto.fecha_inicio }}</p>
          <p><strong>Fecha Fin:</strong> {{ proyecto.fecha_fin || 'En curso' }}</p>
        </div>
        <!-- boton borrar proyecto permanentemente-->
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-danger" @click="confirmarBorrarProyecto">
            <font-awesome-icon icon="fas fa-trash" class="me-1" /> Borrar Proyecto
          </button>
        </div>
      </div>

      <!-- Cierre del Proyecto -->
      <div class="tab-pane fade" id="nav-cierre" role="tabpanel" aria-labelledby="nav-cierre-tab">
        <div class="resumen-cronologico shadow-sm p-3 rounded bg-light">
          <h4>Resumen Cronológico del Proyecto</h4>
          <div class="d-flex justify-content-end mt-3">
            <button class="btn btn-danger" @click="confirmarCerrarProyecto" :disabled="proyecto.proyecto_cerrado">
              <font-awesome-icon icon="fas fa-lock" class="me-1" /> Confirmar Cierre
            </button>
          </div>
          <ResumenProyecto :cronologia="resumenCronologico" />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';
import ResumenProyecto from './resumenProyecto/ResumenProyecto.vue';


export default {
  components: {
    ResumenProyecto,

  },
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      proyecto: {},
      resumenCronologico: [],
    };
  },
  created() {
    this.obtenerProyecto();
    this.obtenerResumenCronologico();
  },
  methods: {
    async obtenerResumenCronologico() {
      try {
        const response = await axios.get(`/api/proyecto/${this.proyecto_id}/resumen_cronologico`);
        this.resumenCronologico = response.data.cronologia;

      } catch (error) {
        console.error('Error al obtener el resumen cronológico:', error);
      }
    },
    confirmarCerrarProyecto() {
      if (confirm('¿Estás seguro de que deseas finalizar este proyecto? Una vez cerrado, no se podrán agregar más tareas, ni crear o editar lotes. Solo estará disponible para visualización y formará parte del histórico de trazabilidad y la documentación formal del proyecto. Esta acción no se puede deshacer.')) {
        axios.put(`/api/proyecto/${this.proyecto_id}/cerrar`)
          .then(() => {
            alert('Proyecto cerrado exitosamente.');
            //darle un f5
            location.reload();
          })
          .catch(error => {
            alert(error.response.data);
            console.error('Error al cerrar el proyecto:', error);
          });
      }
    },
    confirmarBorrarProyecto() {
      if (confirm('¿Estás seguro de que deseas borrar este proyecto? Esta acción no se puede deshacer.')) {
        axios.delete(`/api/proyectos/${this.proyecto_id}`)
          .then(() => {
            alert('Proyecto borrado exitosamente.');
            //limpiar el proyecto del local storage
            localStorage.removeItem('proyecto');
            //limpiar el proyecto del vuex
            this.$store.commit('limpiarProyectoActual');
            //darle un f5
            location.reload();
          })
          .catch(error => {
            alert(error.response.data);
            console.error('Error al borrar el proyecto:', error);
          });
      }
    },
    obtenerProyecto() {
      axios.get(`/api/proyectos/${this.proyecto_id}`)
        .then(response => {
          this.proyecto = response.data;
          this.proyecto.fecha_inicio = new Date(this.proyecto.fecha_inicio).toLocaleDateString();
          if (this.proyecto.fecha_fin) {
            this.proyecto.fecha_fin = new Date(this.proyecto.fecha_fin).toLocaleDateString();
          }
        })
        .catch(error => {
          console.error('Error al obtener el proyecto:', error);
        });
    },
  },
};
</script>

<style scoped>
.administrar-proyecto {
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

.proyecto-info,
.resumen-cronologico {
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  transition: box-shadow 0.3s ease;
}

.proyecto-info:hover,
.resumen-cronologico:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h4 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.nav-tabs .nav-link {
  font-size: 1rem;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.nav-tabs .nav-link.active {
  background-color: var(--app-primary);
  color: #ffffff;
}

.nav-tabs .nav-link:hover {
  color: var(--app-primary);
}

.btn-sm {
  font-size: 0.85rem;
}

.btn-danger {
  transition: background-color 0.3s ease;
}

.btn-danger:hover {
  background-color: #c82333;
}
</style>